import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { ComponentsModule } from 'src/app/components/components.module';

import { ExternalLinkContentComponent } from './external-link-content.component';

@NgModule({
  declarations: [
    ExternalLinkContentComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ComponentsModule
  ]
})
export class ExternalLinkContentModule {}